import { environment } from './../../environments/environment';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import Web3 from 'web3';
import * as WalletConnectProvider from '@walletconnect/web3-provider'
import * as Web3Modal from "web3modal"
import { AbiService } from './abi.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AddTokenAMetamaskService } from './add-metamask.service';
import { Sweetalert2Service } from './sweetalert2.service';
import { toWei, getDateFromBlock, fromWei } from '../helpers/utils';
import { allowance, approve } from '../helpers/abi';
import moment from 'moment';


@Injectable({
  providedIn: 'root'
})
export class ContractService {

  private web3js: any;
  private provider: any;
  public accounts: any;
  _web3Modal: any
  uToken: any
  uTokenStaked: any;
  _atracionesDisponibles: any

  public spinnerConecction = new Subject<any>();
  spinnerConecction$ = this.spinnerConecction.asObservable();

  public accountStatusSource = new Subject<any>();
  accountStatus$ = this.accountStatusSource.asObservable();

  public dataStatusSource = new Subject<any>();
  dataStatus$ = this.dataStatusSource.asObservable();

  public setAccountStakes = new Subject<any>();
  accountStakes$ = this.setAccountStakes.asObservable();

  waitForTransactions = 12000

  constructor(
    private spinner: NgxSpinnerService,
    public sweetalert2Service: Sweetalert2Service,
    public metamaskService: AddTokenAMetamaskService,
    public abiService: AbiService) {

    const providerOptions = {
      walletconnect: {
        package: WalletConnectProvider.default,
        network: "polygon", // here you can change the network
        chainId: environment.chain.chainId,
        options: {
          chainId: environment.chain.chainId,
          infuraId: environment.infuraId, // required,
          rpc: {
            137: "https://polygon-mainnet.g.alchemy.com/v2/" + environment.alchemyId,
            80001: "https://polygon-mumbai.infura.io/v3/" + environment.infuraId,
          },
        },
        display: {
          description: "Scan with a wallet to connect",
        },
      },
    };

    this._web3Modal = new Web3Modal.default({
      network: "mainnet", // optional
      cacheProvider: false, // optional
      providerOptions, // required
      theme: {
        background: "#e5e61d",
        main: "#000000",
        secondary: "rgb(136, 136, 136)",
        border: "rgba(195, 195, 195, 0.14)",
        hover: "rgb(16, 26, 32)"
      }
    });
  }




  // @dev
  async connectAccount() {

    try {
      this.provider = await this._web3Modal.connect();
    } catch (e) {
      console.log("Could not get a wallet connection", e);
      this.sweetalert2Service.showError("Could not get a wallet connection", 2)
      return;
    }

    // console.warn("Opening a dialog", Web3Modal);
    // console.warn("Opening a dialog", this.provider);

    this.web3js = new Web3(this.provider); // create web3 instance
    this.accounts = await this.web3js.eth.getAccounts();

    // console.log("this.accounts",);
    this.provider.on("wc_sessionUpdate", (error, data) => {
      console.log("this.provider.on", error);
      console.log("this.provider.on", data);
    })


    // Subscribe to accounts change
    this.provider.connection = (accounts) => {
      console.log('ACCOUNTS CHANGED' + accounts[0]);
    };



    // this.provider._events.block = (close) => {
    //   console.log("block", close);
    // }

    this.provider._events.close = (x) => {
      console.log("close", x);
      this.logout()
    }

    this.provider._events.disconnect = (x) => {
      console.log("disconnect", x);
      this.logout()
    }


    this.provider._events.connect = (x) => {
      console.log("connect", x);
    }


    this.provider._events.error = (x) => {
      console.log("error", x);
    }

    // this.provider._events.message = (x) => {
    //   console.log("message", x);
    // }

    this.provider._events.start = (x) => {
      console.log("start", x);
    }

    this.provider._events.stop = (x) => {
      console.log("stop", x);
    }
  }

  // @dev
  async reInitializating() {
    console.log("Reinitializing...", this.provider);
    if (this.provider == undefined) {
      return
    }

    if (this.provider.qrcodeModal) {
      this.provider.qrcodeModal.close();
    }

    /** spinner starts on init */

    // --- temporarily re-initializating these for the effect file 
    // this.provider = await this._web3Modal.connect(); // set provider
    // this.web3js = new Web3(this.provider); // create web3 instance
    // this.accounts = await this.web3js.eth.getAccounts();

    let token_abi: any = await this.abiService.getABI(1);
    let token_abiStaked: any = await this.abiService.getABI(2);

    this.uToken = new this.web3js.eth.Contract(token_abi, environment.contractAddress);
    this.uTokenStaked = new this.web3js.eth.Contract(token_abiStaked, environment.contractAddress2);

    this.getData()
  }

  // @dev
  async getData() {
    return new Promise(async (resolve, reject) => {
      try {

        this.spinnerConecction.next(true)

        // console.log("getData")
        let data: any = {}

        data.contractAddress = environment.contractAddress;
        data.accounts = this.accounts[0];

        /** Obtener información del usuario */
        const userData = await this.getUserData();
        data = Object.assign({}, data, userData);
        data.salesInADay = {
          amount: fromWei(data.salesInADay.amount, 18),
          startOfDay: moment(getDateFromBlock(data.salesInADay.startOfDay)).format("DD/MM/YYYY hh:mm A"),
          unlockTime: moment(getDateFromBlock(data.salesInADay.startOfDay)).add(data.lockTime, 'hours').format("DD/MM/YYYY hh:mm A")
        }

        data.buyInADay = {
          amount: fromWei(data.buyInADay.amount, 18),
          startOfDay: moment(getDateFromBlock(data.buyInADay.startOfDay)).format("DD/MM/YYYY hh:mm A"),
          unlockTime: moment(getDateFromBlock(data.buyInADay.startOfDay)).add(data.lockTime, 'hours').format("DD/MM/YYYY hh:mm A")
        }



        /** Obtener información del oraculo */
        const oracleData = await this.getOracleContractData();
        data = Object.assign({}, data, oracleData);


        // Si es el OWNER
        if (data.owner == this.accounts[0]) {
          const ownerData = await this.getOwnerData();
          data = Object.assign({}, data, ownerData);
        }

        console.log("getData", data);

        this.dataStatusSource.next(data);
        this.spinnerConecction.next(false)
        resolve('ok');
      } catch (err) {
        this.dataStatusSource.next(null);
        this.spinnerConecction.next(false)
        reject(err);
      }

    })
  }


  // @dev
  async logout() {
    console.log("Killing the wallet connection", this.provider);
    console.log("this.provider.close()", this.provider.close);

    this.dataStatusSource.next(null)
    this.spinnerConecction.next(false)

    // TODO: Which providers have close method?
    if (this.provider.close) {
      await this.provider.close();

      // If the cached provider is not cleared,
      // WalletConnect will default to the existing session
      // and does not allow to re-scan the QR code with a new wallet.
      // Depending on your use case you may want or want not his behavir.
      this.provider = null;

    }
    await this._web3Modal.clearCachedProvider();
    window.location.reload();

  }


  // @dev
  getAbiContract(token_abi, token_address) {
    let uToken: any = new this.web3js.eth.Contract(token_abi, token_address);
    return uToken;
  }


  // @dev
  getAllowance(addresstoken) {
    return new Promise(async (resolve, reject) => {
      try {

        // cargamos la abi de contracto secundarios con el metodo approve
        let utoken: any = this.getAbiContract(allowance, addresstoken)


        let result = await utoken
          .methods
          .allowance(this.accounts[0], environment.contractAddress)
          .call({ from: this.accounts[0] })

        // console.log("result", result)

        resolve(result)
      } catch (err) {
        console.log("error", err)
        this.sweetalert2Service.showError("Error", 2)
        resolve(false)
      }

    })
  }

  // @dev
  async getBlock() {
    const latestBlock: any = await this.web3js.eth.getBlock('latest');
    const blockGas = latestBlock.gasLimit;
    return blockGas;
  }


  // @dev
  getApproveTokenAddress(addresstoken: string, amount: string, decimals, contractAddress) {
    return new Promise(async (resolve, reject) => {
      try {

        // cargamos la abi de contracto secundarios con el metodo approve
        let utoken = this.getAbiContract(approve, addresstoken)

        let account = this.accounts[0]
        let tokenTotal = toWei(amount, decimals)
        console.warn("tokenTotal", tokenTotal)

        // hacemmos la consulta
        let _gas = await utoken
          .methods
          .approve(contractAddress, tokenTotal)
          .estimateGas({ from: account })

        console.log("_gas", _gas)
        // We now have the gas amount, we can now send the transaction
        utoken
          .methods
          .approve(contractAddress, tokenTotal)
          .send({
            from: account,
            gas: _gas
          })
          .on('transactionHash', (hash) => {
            console.log("hash", hash)
            setTimeout(() => {
              resolve(true)
            }, this.waitForTransactions)
          })

          .on('receipt', (receipt) => {
            console.log("receipt", receipt)
          })
          .on('confirmation', (confirmationNumber, receipt) => {
            console.log("confirmationNumber", confirmationNumber)
            console.log("receipt", receipt)
          })
          .on('error', (err) => {
            console.log("error", err.message)
            this.sweetalert2Service.showError(err.message, 2)
            this.spinnerConecction.next(false)
          })


      } catch (err) {
        console.log("error", err)
        this.sweetalert2Service.showError("Error", 2)
        resolve(false)
      }

    })
  }


  /**
   * Obtener datos del oraculo
   * @returns 
   */
  async getOracleContractData() {
    const [
      getLatestPriceMATICUSD,
      getLatestPriceWBTCUSD,
      getLatestPriceWETHUSD,
      getLatestPriceCOPUSD,
      getLatestPriceUSDCOP,
    ] = await Promise.all([
      this._method("getLatestPriceMATICUSD", 'methods'),
      this._method("getLatestPriceWBTCUSD", 'methods'),
      this._method("getLatestPriceWETHUSD", 'methods'),
      this._method("getLatestPriceCOPUSD", 'methods'),
      this._method("getLatestPriceUSDCOP", 'methods'),
    ]);

    return Object.assign({
      getLatestPriceMATICUSD,
      getLatestPriceWBTCUSD,
      getLatestPriceWETHUSD,
      getLatestPriceCOPUSD,
      getLatestPriceUSDCOP,
    });
  }


  /**
   * Obtener datos del usuario
   * @returns 
   */
  async getUserData() {
    const [
      myEther = 0,
      balanceOfdly = 0,
      balanceOfUSDT = 0,
      balanceOfUSDC = 0,
      balanceOfBTC = 0,
      balanceOfETH = 0,
      owner,

      fee_fixed,
      fee_fixed_dly,

      myContractEther,
      balanceOfdlyContract,
      balanceOfUSDTContract,
      balanceOfUSDCContract,
      balanceOfBTCContract,
      balanceOfETHContract,

      salesInADay,
      buyInADay,

      lockTime,

    ] = await Promise.all([

      this.getBalanceEth(this.accounts[0]),
      this._method("balanceOfdly", 'methods', this.accounts[0]),
      this._method("balanceOfUSDT", 'methods', this.accounts[0]),
      this._method("balanceOfUSDC", 'methods', this.accounts[0]),
      this._method("balanceOfBTC", 'methods', this.accounts[0]),
      this._method("balanceOfETH", 'methods', this.accounts[0]),
      this._method("owner", 'methods'),


      this._method("fee_fixed", 'methods'),
      this._method("fee_fixed_dly", 'methods'),


      this.getBalanceEth(environment.contractAddress),
      this._method("balanceOfdly", 'methods', environment.contractAddress),
      this._method("balanceOfUSDT", 'methods', environment.contractAddress),
      this._method("balanceOfUSDC", 'methods', environment.contractAddress),
      this._method("balanceOfBTC", 'methods', environment.contractAddress),
      this._method("balanceOfETH", 'methods', environment.contractAddress),

      this._method("salesInADay", 'methods', this.accounts[0]),
      this._method("buyInADay", 'methods', this.accounts[0]),

      this._method("lockTime", 'methods'),

    ]);

    return Object.assign({
      myContractEther,

      myEther,
      balanceOfdly,
      balanceOfUSDT,
      balanceOfUSDC,
      balanceOfBTC,
      balanceOfETH,
      owner,

      fee_fixed,
      fee_fixed_dly,

      balanceOfdlyContract,
      balanceOfUSDTContract,
      balanceOfUSDCContract,
      balanceOfBTCContract,
      balanceOfETHContract,

      salesInADay,
      buyInADay,

      lockTime,

    });
  }


  /**
   * Obtener información de acceso para el propietario
   * @returns 
   */
  async getOwnerData() {
    const [
      balanceOfdlyAdmin = 0,
      balanceOfUSDTAdmin = 0,
      balanceOfUSDCAdmin = 0,
      balanceOfBTCAdmin = 0,
      balanceOfETHAdmin = 0,

      trmCopUsdManual,
      trmUsdCopManual,
      trmMaticUsdManual,
      trmWbtcUsdManual,
      trmWethUsdManual,

      daySellLimit,
      dayBuyLimit,
    ] = await Promise.all([


      this._method("trmCopUsdManual", 'methods'),
      this._method("trmUsdCopManual", 'methods'),
      this._method("trmMaticUsdManual", 'methods'),
      this._method("trmWbtcUsdManual", 'methods'),
      this._method("trmWethUsdManual", 'methods'),

      this._method("valueTrmCopUsdManual", 'methods'),
      this._method("valueTrmUsdCopManual", 'methods'),
      this._method("valueTrmMaticUsdManual", 'methods'),
      this._method("valueTrmWbtcUsdManual", 'methods'),
      this._method("valueTrmWethUsdManual", 'methods'),

      this._method("daySellLimit", 'methods'),
      this._method("dayBuyLimit", 'methods'),

    ]);

    return Object.assign({
      balanceOfdlyAdmin,
      balanceOfUSDTAdmin,
      balanceOfUSDCAdmin,
      balanceOfBTCAdmin,
      balanceOfETHAdmin,

      trmCopUsdManual,
      trmUsdCopManual,
      trmMaticUsdManual,
      trmWbtcUsdManual,
      trmWethUsdManual,

      daySellLimit,
      dayBuyLimit,
    });
  }




  /**
   * Método comun para realizar peticiones
   * @param method 
   * @param type 
   * @param params 
   * @returns 
   */
  async _method(method: string, type: string, params?: any) {
    const toAwait: any[] = [];

    if (method == 'allowance') {
      toAwait.push(this.uToken[type][method](params, environment.contractAddress).call());
    }
    else if (params) {
      toAwait.push(this.uToken[type][method](params).call());
    } else {
      toAwait.push(this.uToken[type][method]().call());
    }

    try {
      const [result] = await Promise.all(toAwait);
      return result;
    } catch (err) {
      console.log('Error on ContractService@_method', err);
      return;
    }
  }

  // @dev
  checkNetwork() {
    this.web3js.eth.net.getId()
      .then(id => {
        if (id != environment.chain.chainId) {
          this.sweetalert2Service.showWarning('Por favor cambie a la red Polygon Network Smart', 2);
          this.metamaskService.addEthereumChain()
        }
      })
  }


  // @dev
  _methods() {
    return this.uToken.methods
  }

  // @dev
  getDataContract() {
    let data: any = localStorage.getItem('_data_contract');
    if (data == "") { return "" }
    return JSON.parse(data)
  }


  /**
  * @notice  verify that the address is valid
  */
  getBalanceEth(account: string) {
    return new Promise((resolve, reject) => {
      this.web3js.eth.getBalance(account, (err, res) => {
        if (err) {
          console.log(err)
          reject(err)
        } else {
          resolve(res)
        }
      })
    })
  }

}